import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Heading, Image, Stack, Text } from "@chakra-ui/react";

import { RoutesMap } from "../../../../../routes.tsx";
import sandClockIcon from "../../../../../assets/sandClock.png";

export const SbpTransferResultPageInProgress: FC = () => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(RoutesMap.index);
  };

  return (
    <Stack spacing={0} flex="1" alignItems="center" textAlign="center">
      <Image w="173px" h="145px" src={sandClockIcon} mb="22px" />

      <Heading mb="8px">Перевод в обработке</Heading>

      <Text fontSize="14px" mb="30px">
        Это может занять некоторое время
      </Text>

      <Button w="100%" colorScheme="purple" onClick={onClick}>
        Вернуться на главную
      </Button>
    </Stack>
  );
};
